import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Utils } from "../../utils/common-utils";

import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

export default function OutlinedCard(props: any) {
  const greycol = "1px solid yellow";
  return (
    <Card
      variant="outlined"
      sx={{
        "&:hover": {
          cursor: "pointer",
          boxShadow: "1px 1px 5px 1px rgb(24, 144, 255)",
        },
     border:props.border
      }}
    >
      <CardContent>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 800,
            textAlign: "center",
            color: "black",
          }}
          color="text.secondary"
          gutterBottom
        >
          {props.value}
          {console.log(props)}
        </Typography>
        {/* <Typography sx={{fontSize:25, fontWeight: 1000 ,textAlign:"center"}}>$ 629</Typography> */}

        {/* <Typography sx={{ mb: 1.5 }} color="text.secondary"> */}
        {props.value === 'PLUS' ? <Typography className="popularPlan">(Most popular)</Typography>
        :<Typography className="popularPlan">&nbsp;</Typography>}
        <Typography className="planPrice"><h2>{Utils.formatNumber(props.featurePrice || 0, true, true)}</h2></Typography>
        <Typography className="planPriceDesc">{props.featurePriceDesc}</Typography>
        <List sx={{height:'330px'}}>
          {props.featuresData.map((feature: any, index: any) => {
            return (
              <><ListItem key={index} sx={{  spacing: 0 }}>
                <ListItemIcon>
                  <CheckIcon color="success" fontSize="small" />
                </ListItemIcon>

                <ListItemText primary={feature} sx={{ ml: -2 }} />

              </ListItem><Divider  variant="middle" /></>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );
}
